// extracted by mini-css-extract-plugin
export default {"wrapper":"LimpopoMap_wrapper__z8Pvv","map":"LimpopoMap_map__ybG-F"};